(function() {

  var $self = this;
  $self.ProjectsAndPartnerships             = $self.ProjectsAndPartnerships             || {};
  $self.ProjectsAndPartnerships.initiatives = $self.ProjectsAndPartnerships.initiatives || {};

  $self.ProjectsAndPartnerships.initiatives.npsIndexData = [
    {
      id: 35,
      // short_name: 'christiansted',
      textParams: {
        posModX: function(c) {return c - 73; },
        posModY: function(c) {return c + 5; }
      }
    },
    {
      id: 57,
      // short_name: Yellowstone
      textParams: {
        posModX: function(c) {return c - 15; },
        posModY: function(c) {return c - 9; }
      }
    },
    {
      id: 51,
      // short_name: Rocky Mountain
      textParams: {
        posModX: function(c) {return c - 40; },
        posModY: function(c) {return c + 15; }
      }
    },
      {
          id: 41,
          // short_name: Great Smoky Mountains
          textParams: {
              posModX: function(c) {return c - 120; },
              posModY: function(c) {return c + 15; }
          }
      },
      {
          id: 48,
          // short_name: Pea Ridge
          textParams: {
              posModX: function(c) {return c - 40; },
              posModY: function(c) {return c + 15; }
          }
      },
      {
          id: 150,
          // short_name: Carl Sandburg
          textParams: {
              posModX: function(c) {return c; },
              posModY: function(c) {return c + 15; }
          }
      },
      {
          id: 30,
          // short_name: Mammoth Cave
          textParams: {
              posModX: function(c) {return c - 20; },
              posModY: function(c) {return c - 10; }
          }
      },
    {
      id: 59,
      // short_name: Zion
      textParams: {
        posModX: function(c) {return c - 30; },
        posModY: function(c) {return c + 3; }
      }
    },
    {
      id: 117,
      // short_name: Pipe Spring
      textParams: {
        posModX: function(c) {return c - 30; },
        posModY: function(c) {return c + 15; }
      }
    },
    {
      id: 115,
      // short_name: Cedar Breaks
      textParams: {
        posModX: function(c) {return c - 30; },
        posModY: function(c) {return c - 9; }
      }
    },
    {
      id: 50,
      // short_name: Point Reyes
      textParams: {
        posModX: function(c) {return c - 15; },
        posModY: function(c) {return c - 9; }
      }
    },
    {
      id: 47,
      // short_name: Nicodemus
      textParams: {
        posModX: function(c) {return c - 15; },
        posModY: function(c) {return c - 9; }
      }
    },
    {
      id: 53,
      // short_name: Scotts Bluff
      textParams: {
        posModX: function(c) {return c - 19; },
        posModY: function(c) {return c - 9; }
      }
    },
    {
      id: 56,
      // short_name: Wilson's Creek
      textParams: {
        posModX: function(c) {return c - 30; },
        posModY: function(c) {return c - 9; }
      }
    },
    {
      id: 36,
      // short_name: Florissant Fossil Beds
      textParams: {
        posModX: function(c) {return c - 40; },
        posModY: function(c) {return c + 15; }
      }
    },
    {
      id: 45,
      // short_name: Mississippi River
      textParams: {
        posModX: function(c) {return c - 40; },
        posModY: function(c) {return c + 15; }
      }
    },
    {
      id: 42,
      // short_name: Independence
      textParams: {
        posModX: function(c) {return c + 9; },
        posModY: function(c) {return c + 3; }
      }
    },
    {
      id: 46,
      // short_name: National Mall
      textParams: {
        posModX: function(c) {return c + 9; },
        posModY: function(c) {return c + 3; }
      }
    },
    {
      id: 33,
      // short_name: Catocin
      textParams: {
        posModX: function(c) {return c - 25; },
        posModY: function(c) {return c - 9; }
      }
    },
    // {
    //   id: 116,
    //   // eh, we might mod this? but not needed at time of writing.
    //   // short_name: 'Petroglyph National Monument',
    //   // textParams: {
    //   //   posModX: function(c) {return c - 25; },
    //   //   posModY: function(c) {return c - 9; }
    //   // }
    // },
    {
      id: 49,
      // short_name: 'Petrified Forest',
      textParams: {
        posModX: function(c) {return c - 83; },
        posModY: function(c) {return c + 3; }
      }
    },
  ];


}).call(CC);
